export var ENV = {
    NODE_ENV: process.env.NODE_ENV || '',
    APP_STORAGE_KEY: process.env.APP_STORAGE_KEY || '',
    APP_ACCESS_TOKEN: process.env.APP_ACCESS_TOKEN || '',
    BFF_URL: process.env.BFF_URL || '',
    BFF_APP_URL: process.env.BFF_APP_URL || '',
    APP_DOMAIN_URL: process.env.APP_DOMAIN_URL || '',
    SHOW_REDUX_LOGGER: process.env.SHOW_REDUX_LOGGER === 'true',
    APP_LOG_ROCKET_ID: process.env.APP_LOG_ROCKET_ID || '',
    APP_GA_ID: process.env.APP_GA_ID || '',
    APP_BEAMER_ID: process.env.APP_BEAMER_ID || '',
    APP_SEGMENT_ID: process.env.APP_SEGMENT_ID || '',
    SHOW_APOLLO_LOGGER: process.env.SHOW_APOLLO_LOGGER === 'true',
    APP_REFRESH_TOKEN_GAP: process.env.APP_REFRESH_TOKEN_GAP || '',
    APP_SESSION_IDLE: process.env.APP_SESSION_IDLE || '',
    APP_URL: process.env.APP_URL || '',
    COCKPIT_URL: process.env.COCKPIT_URL || '',
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN || '',
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID || '',
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE || '',
};
